import { t } from "@lingui/macro";
import { ArrowRight, Check } from "@phosphor-icons/react";
import { Button } from "@stylingcv/ui";
import { cn } from "@stylingcv/utils";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const FinalCTASection = () => {
  return (
    <section id="final-cta" className="relative overflow-hidden bg-[#050505] py-24 sm:py-32">
      {/* Background glow */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="h-[40vh] w-[80vw] rounded-full bg-emerald-500/10 blur-[120px]" />
      </div>

      <div className="container relative z-10 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          {/* Main Heading */}
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-6 font-sans text-4xl lg:text-5xl font-bold tracking-tighter text-white"
          >
            {t`Ready to Land Your Dream Job?`}
          </motion.h2>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-10 text-center text-lg font-light text-white/60 max-w-2xl mx-auto"
          >
            {t`Stop being rejected by robots. Start getting interviews.`}
          </motion.p>

          {/* Action Button */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-col items-center justify-center text-center"
          >
            <Button
              asChild
              size="lg"
              className="group relative flex items-center gap-3 overflow-hidden rounded-full bg-emerald-400 pl-8 pr-3 py-7 text-lg font-bold text-emerald-950 transition-all hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_40px_-10px_rgba(16,185,129,0.5)] hover:bg-emerald-300"
            >
              <Link to="/ai-generator">
                {t`Create Your Winning Resume`} 
                <span className="flex size-10 items-center justify-center rounded-full bg-white/20 transition-transform group-hover:translate-x-1 group-hover:-translate-y-[1px]">
                  <ArrowRight weight="bold" className="size-5" />
                </span>
              </Link>
            </Button>
          </motion.div>

          {/* Trust Indicators */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="mt-12 flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-sm font-medium text-white/50 uppercase tracking-wide"
          >
            <div className="flex items-center gap-2">
              <Check weight="bold" className="size-4 text-emerald-400" />
              <span>{t`Free to try`}</span>
            </div>
            <div className="flex items-center gap-2">
              <Check weight="bold" className="size-4 text-emerald-400" />
              <span>{t`No credit card`}</span>
            </div>
            <div className="flex items-center gap-2">
              <Check weight="bold" className="size-4 text-emerald-400" />
              <span>{t`Ready in 5 minutes`}</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
